import { useEffect } from "react";
import { usePartnerStore } from "@/stores/partner.store";
import { applyPreset } from "@/lib/theme";

/**
 * Fetches partner config on mount and applies CSS overrides.
 * Render once near the root of the app (e.g. in App.tsx or main layout).
 */
export function PartnerTheme() {
  const { config, fetchConfig } = usePartnerStore();

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  useEffect(() => {
    if (!config) return;
    const root = document.documentElement;
    applyPreset(config.theme);

    // Override primary color if set
    if (config.primary_color && config.primary_color !== "#8b5cf6") {
      root.style.setProperty("--primary", config.primary_color);
      root.style.setProperty("--ring", config.primary_color);
    }

    // Optional: sidebar background
    if (config.sidebar_bg) {
      root.style.setProperty("--sidebar", config.sidebar_bg);
    }


    return () => {
      // Cleanup on unmount
      root.style.removeProperty("--primary");
      root.style.removeProperty("--ring");
      root.style.removeProperty("--sidebar");
    };
  }, [config]);

  return null;
}
